export default __webpack_public_path__ + "static/media/palm-trees.c7a2a421.png";